import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    colors: {
      violetBlue: string;
      purple: string;
      darkPurple: string;
      white: string;
      white10: string;
      lighterGrey: string;
      grey: string;
      black: string;
      darkerGrey: string;
      gold: string;
    };
  }
  // allow configuration using `createTheme()`
  interface ThemeOptions {
    colors?: {
      violetBlue?: string;
      purple?: string;
      darkPurple?: string;
      white?: string;
      white10?: string;
      lighterGrey?: string;
      grey?: string;
      black?: string;
      darkerGrey?: string;
      gold?: string;
    };
  }
}

export const theme = createTheme({
  colors: {
    white: '#ffffff',
    white10: '#FFFFFF1A',
    black: '#000000',
    violetBlue: '#534cd4',
    purple: '#6f51e4',
    darkPurple: '#201428',
    lighterGrey: '#878787',
    grey: '#323232',
    darkerGrey: '#181818',
    gold: '#F5E2BE',
  },
  typography: {
    fontFamily: `'Plus Jakarta Sans', sans-serif`,
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});
